export default __webpack_public_path__ + "static/media/3counter.d9ae0c70.jpg";